export const QUERY_KEYS = {
  config: 'config',
  map: {
    surfaceMapsLayer: 'surfaceMapsLayer',
    fwePoints: 'fwePoints',
    insituPoints: 'insituPoints',
    moodSpace: 'moodSpace',
    globalLayer: 'globalLayer',
    fweModelDomain: 'fweModelDomain',
    geojsonLayer: 'geojsonLayer',
    overlay: {
      shapeFile: 'overlayShapeFile',
      surfaceMap: 'overlaySurfaceMap',
      geoJson: 'overlayGeoJson',
    },
  },
  user: {
    currentUser: 'currentUser',
    getUserProfile: 'getUserProfile',
  },
  metadata: {
    getMetadata: 'getMetadata',
  },
  analytics: {
    preprocessedAnalytics: 'preprocessedAnalytics',
  },
  dataset: {
    price: 'price',
    waterDepth: 'waterDepth',
    metadata: 'metadata',
    metadataPreview: 'metadataPreview',
    dataPreview: 'dataPreview',
    datasetBriefs: 'datasetBriefs',
    datasetBriefsFwe: 'datasetBriefsFwe',
    bestDatasets: 'bestDatasets',
    extraction: 'extraction',
  },
  order: {
    directDownload: 'directDownload',
  },
  price: {
    period: 'period',
  },
  home: {
    notification: 'notifications',
    bsApi: 'bsApi',
  },
  upload: {
    shapeFile: 'shapeFile',
    checkStatus: 'checkStatusUploadFile',
    geojsonShapeFile: 'geojsonShapefile',
  },
  cart: {
    getShoppingCart: 'getShoppingCart',
    preCheckoutCheck: 'preCheckoutCheck',
    priceSummary: 'priceSummary',
  },
  plot: {
    roseplot: 'rosePlot',
    timeseries: 'timeseries',
  },
  waveSpectra: {
    spectrum: 'waveSpectrum',
    timeseries: 'waveSpectrumTimeseries',
  },
};
export const MUTATION_KEYS = {
  dataset: {
    bestDatasets: 'bestDatasets',
  },
  map: {
    surfaceMaps: 'surfaceMaps',
  },
  cart: {
    deleteShoppingItem: 'deleteShoppingItem',
    createOrder: 'createOrder',
    clearCart: 'clearCart',
    getSampleData: 'getSampleData',
  },
  user: {
    updateUserProfile: 'updateUserProfile',
  },
  chart: {
    preprocessedAnalytics: 'preprocessedAnalytics',
    getAdvancedAnalytics: 'getAdvancedAnalytics',
  },
  service: {
    createFullExtractionTasks: 'createFullExtractionTasks',
  },
  report: {
    createReport: 'createReport',
  },
};

/**
 * Query keys used by `LoadModal` to check if request is pending
 */
export const QUERY_KEYS_TO_MONITOR = [
  QUERY_KEYS.config,
  QUERY_KEYS.map.moodSpace,
  QUERY_KEYS.map.globalLayer,
  QUERY_KEYS.map.fweModelDomain,
  QUERY_KEYS.map.overlay.surfaceMap,
  QUERY_KEYS.map.overlay.shapeFile,
  QUERY_KEYS.dataset.datasetBriefs,
  QUERY_KEYS.dataset.bestDatasets,
  QUERY_KEYS.dataset.datasetBriefsFwe,
  QUERY_KEYS.dataset.metadata,
  QUERY_KEYS.dataset.waterDepth,
  QUERY_KEYS.order.directDownload,
  QUERY_KEYS.user.currentUser,
  QUERY_KEYS.home.notification,
  QUERY_KEYS.home.bsApi,
] as const;

/**
 * Mutation keys used by `LoadModal` to check if request is pending
 */
export const MUTATION_KEYS_TO_MONITOR = [
  MUTATION_KEYS.dataset.bestDatasets,
] as const;
